import { defineMessages } from 'react-intl';

export default defineMessages({
    setupPasswordTitle: {
        id: 'app.resetPassword.setNewPassword.setupPasswordTitle',
        defaultMessage: 'Create your new password'
    }
});
